/**
 *
 * @param promise
 * @return {*}
 */
export default (promise) => promise.then(response => {
  const {ok, status, statusText} = response;

  // Resolve only response with status inside the range 200-299
  if(ok){
    return response;
  }

  return Promise.reject(new Error(`HTTP error ${response.status}: ${response.statusText}`));
})
